/** SFL layout tokens — web (see DESIGN_STYLE.md) */

export const sflRadius = {
  sm: 10,
  md: 14,
  lg: 20,
} as const;

export const sflGap = {
  card: 8,
  grid: 10,
  row: 12,
} as const;

export const sflCardPadding = {
  default: 16,
  row: 12,
} as const;

export const sflTypography = {
  sectionLetterSpacing: '0.06em',
} as const;

export const sflMotion = {
  pressDuration: 150,
} as const;

/** Fluid scale — clamp for responsive type (approx. mvs intent) */
export function mvs(px: number, min = 0.92, max = 1.08): string {
  const minPx = Math.round(px * min);
  const maxPx = Math.round(px * max);
  return `clamp(${minPx}px, ${px * 0.06}rem + 1.5vw, ${maxPx}px)`;
}

export type SflSemantic = 'accent' | 'blue' | 'teal' | 'amber' | 'coral' | 'pink' | 'green';

export type SflContentKind =
  | 'reading'
  | 'video'
  | 'recipe'
  | 'shopping'
  | 'news'
  | 'work'
  | 'travel'
  | 'default';

export function sflSemanticForContent(kind: SflContentKind): SflSemantic {
  const map: Record<SflContentKind, SflSemantic> = {
    reading: 'blue',
    video: 'coral',
    recipe: 'amber',
    shopping: 'pink',
    news: 'teal',
    work: 'accent',
    travel: 'green',
    default: 'accent',
  };
  return map[kind] ?? 'accent';
}
